export default __webpack_public_path__ + "static/media/copy.6b9d12c2.svg";